import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';

interface SortableThProps {
  label: string;
  /** The backend sort column this header drives (must be server-whitelisted). */
  field: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc' | string;
  onToggle: (field: string) => void;
  className?: string;
  align?: 'left' | 'right' | 'center';
}

/** Clickable table header that drives a server-side `sort_by`/`sort_order`.
 *  Shared across the admin list pages (users, role types, permissions). */
const SortableTh = ({
  label,
  field,
  sortBy,
  sortOrder,
  onToggle,
  className = '',
  align = 'left',
}: SortableThProps) => {
  const active = sortBy === field;
  const alignClass =
    align === 'right' ? 'text-right justify-end' : align === 'center' ? 'text-center justify-center' : 'text-left';
  return (
    <th
      className={`px-6 py-3 text-xs font-medium uppercase tracking-wider text-gray-500 ${alignClass} ${className}`}
    >
      <button
        type="button"
        onClick={() => onToggle(field)}
        className={`group inline-flex items-center gap-1 uppercase tracking-wider hover:text-gray-800 ${
          active ? 'text-gray-800' : ''
        }`}
        aria-label={`Sort by ${label}`}
      >
        {label}
        {active ? (
          sortOrder === 'asc' ? (
            <ArrowUp className="h-3.5 w-3.5" />
          ) : (
            <ArrowDown className="h-3.5 w-3.5" />
          )
        ) : (
          <ChevronsUpDown className="h-3.5 w-3.5 text-gray-300 group-hover:text-gray-400" />
        )}
      </button>
    </th>
  );
};

export default SortableTh;
